import React, { useMemo } from "react";
import GenericFormTab from "../shippment/tabs/GenericFormTab";
import CommonDataTable from "../../components/CommonDataTable";
import {
    adjustmentHeaderFields,
    adjustmentDetailColumns
} from "./formFields/adjustmentFields";

export default function ViewAdjustment({ initialValues = {}, onCancel }) {
    const headerData = useMemo(() => {
        const h = initialValues?.AdjHeader ?? {};
        return {
            ...h,
            editdate: h.editdate?.$date
                ? new Date(h.editdate.$date).toLocaleDateString("en-GB")
                : h.editdate
                    ? new Date(h.editdate).toLocaleDateString("en-GB")
                    : "",
        };
    }, [initialValues]);

    const itemRows = useMemo(() => {
        const details = initialValues?.AdjDetails ?? [];
        return details.map((d, idx) => ({
            id: idx + 1,
            lineNo: idx + 1,
            Adjustmentlinenumber: d.Adjustmentlinenumber ?? "",
            Sku: d.Sku ?? "",
            Description: d.Description ?? "",
            Location: d.Location ?? "",
            Lot: d.Lot ?? "",
            LPN: d.LPN ?? "",
            Quantity: d.Quantity ?? 0,
            ReasonCode: d.ReasonCode ?? "",
            PackKey: d.PackKey ?? "",
            UOM: d.UOM ?? "",
            Notes: d.Notes ?? "",
            Status: d.Status ?? "",
            NetWeight: d.NetWeight ?? 0,
            Lottable01: d.Lottable01 ?? "",
            Lottable02: d.Lottable02 ?? "",
            Lottable09: d.Lottable09 ?? "",
            Lottable10: d.Lottable10 ?? "",
            CountSequence: d.CountSequence ?? 0,
        }));
    }, [initialValues]);

    return (
        <>
            <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
                <span className="text-muted">Adjustment Header</span>
            </div>

            <div className="card mb-4 border-0 shadow-none">
                <div>
                    <GenericFormTab
                        fields={adjustmentHeaderFields}
                        formData={headerData}
                        readOnly
                    />
                </div>
            </div>

            <div className="mb-3 border-bottom pb-2 d-flex gap-4 text-primary fw-semibold">
                <span className="text-muted">Adjustment Details</span>
            </div>

            <CommonDataTable
                id="adjustment-items-view"
                allPossibleColumns={adjustmentDetailColumns}
                initialVisible={adjustmentDetailColumns.map((c) => c.field)}
                initialRows={itemRows}
                height={380}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                checkboxSelection={false}
                enableImportButton={false}
                enableExportButton={false}
                forInventory={false}
                readOnly
            />

            <div className="d-flex justify-content-center mt-4">
                <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
            </div>
        </>
    );
}
